import { API_BASE_URL, ACCESS_TOKEN } from "../constants";

const request = (options) => {
  const headers = new Headers({
    "Content-Type": "application/json",
  });

  if (localStorage.getItem(ACCESS_TOKEN)) {
    headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem(ACCESS_TOKEN)
    );
  }

  const defaults = { headers: headers };
  options = Object.assign({}, defaults, options);

  return fetch(options.url, options).then((response) =>
    response.json().then((json) => {
      if (!response.ok) {
        return Promise.reject(json);
      }
      return json;
    })
  );
};

export function getCurrentUser() {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return request({
    url: API_BASE_URL + "/user/me",
    method: "GET",
  });
}

export function login(loginRequest) {
  return request({
    url: API_BASE_URL + "/auth/login",
    method: "POST",
    body: JSON.stringify(loginRequest),
  });
}

export function signup(signupRequest) {
  return request({
    url: API_BASE_URL + "/auth/signup",
    method: "POST",
    body: JSON.stringify(signupRequest),
  });
}

export function verify(code) {
  return request({
    url: API_BASE_URL + "/auth/verify?code=" + code,
  });
}

export function forgotPassword(forgotRequest) {
  return request({
    url: API_BASE_URL + "/auth/forgot-password",
    method: "POST",
    body: JSON.stringify(forgotRequest),
  });
}

export function verifyForgotPassword(resetPasswordRequest) {
  return request({
    url: API_BASE_URL + "/auth/verify-forgot-password",
    method: "POST",
    body: JSON.stringify(resetPasswordRequest),
  });
}

export function checkTokenForgotPassword(tokenRequest) {
  return request({
    url: API_BASE_URL + "/auth/check-token-forgot-password",
    method: "POST",
    body: JSON.stringify(tokenRequest),
  });
}

export function getClientInfo(code) {
  return request({
    url: API_BASE_URL + "/client/" + code,
  });
}



// WEBPACK FOOTER //
// ./src/util/APIUtils.js